import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../../Theme'
import { Breadcrumbs } from '../../BreadCrumbs/BreadCrumbs'
import CategoryTagsContainer from '../../../CategoryPage/CategoryTagsContainer'
import CategoryFallback from '../../../../svg/fallback-category.webp'
import { stringByPropertyNameHasValidValue } from '../../Util/Helpers'

const HeroContainer = styled.div`
   position: relative;
   .page-hero-title {
      font-size: 2.8rem;
      font-weight: 700;
   }

   .page-hero-second {
      position: relative;
      border-radius: 2rem 0 0 0;
      overflow: hidden;
   }

   .page-hero-description {
      p {
         font-size: 1rem;  
         font-family: var(--font-industry);
      }
      h1 {
         font-family: var(--font-industry);
         font-size: 1.5rem;
      }
      h2 {
         font-family: var(--font-industry);
         font-size: 1.4rem;
      }
      h3 {
         font-family: var(--font-industry);
         font-size: 1.3rem;
      }
      h4 {
         font-family: var(--font-industry);
         font-size: 1.2rem;
      }
      /* max-height: 800px; */
      /* overflow-y: auto; */
   }

   .page-hero-second .img-background {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      height: 100%;
      width: 100%;
      object-fit: cover;
   }

   .page-hero-first {
   }
`

const BlogDesktopBanner = ({
   bannerContent,
   activeCategory,
   parents,
   showDescriptionContent,
   imageUrl,
   hideCategoryTags
}) => {

   return (
      <HeroContainer className="page-hero">
         <div className="row p-0 m-0">
            <div className="page-hero-first col-12 col-xl-6 pt-64 pb-32 pr-32 pl-128 d-flex flex-column justify-content-between">
               <div className="page-hero-first-top d-flex flex-column">
                  <Breadcrumbs
                     hideLast
                     parents={parents}
                     title={
                        activeCategory?.breadcrumbText || activeCategory?.name
                     }
                     className="mb-3"
                  />
                  <h1 className="page-hero-title">{activeCategory?.name}</h1>
               </div>
               <div className="page-hero-first-bottom d-flex flex-column">
                  {showDescriptionContent && (
                     <article className="page-hero-description pt-16 pb-0 m-0">
                        {bannerContent}
                     </article>
                  )}
                  { !hideCategoryTags &&
                  <CategoryTagsContainer
                     category={activeCategory}
                  ></CategoryTagsContainer>
                  }
               </div>
            </div>
            <div className="page-hero-second col-12 col-xl-6 p-0">
               <div className="page-hero-bg-image">
                  <img
                     className="img-background img-fluid"
                     src={ imageUrl ?? CategoryFallback}
                     alt={activeCategory?.name}
                  />
               </div>
            </div>
         </div>
      </HeroContainer>
   )
}

export default BlogDesktopBanner
